import { Arrow } from "./Icons";
import { track, type AnalyticsEvent } from "../lib/analytics";
export default function ExternalLink({
  href,
  children,
  event,
}: {
  href: string | null;
  children: React.ReactNode;
  event?: AnalyticsEvent;
}) {
  return href ? (
    <a
      className="text-link"
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
      onClick={() => event && track(event)}
    >
      {children}
      <Arrow diagonal />
      <span className="sr-only">
        {href.startsWith("http") ? " (opens in a new tab)" : ""}
      </span>
    </a>
  ) : (
    <span className="missing-link">
      {children}
      <span className="mono">Link to be added</span>
    </span>
  );
}
